import Vue, { CreateElement } from 'vue'
import { Button } from '@src/elements/button/button'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'
import type { WorkoutLiveData } from '@src/state/store'
import { Prop } from 'vue-property-decorator'
import { Icon } from '@src/elements/icon/icon'
import { WorkoutExercise } from '@src/data/workout-exercise'
import WorkoutData from '@src/data/workout-data'
import Component from 'vue-class-component'

import './live-workout.sass'
import {
  MobileLandscapeNotSupportedOverlay
} from '@src/components/mobile-landscape-not-supported-overlay/MobileLandscapeNotSupportedOverlay'

@Component
export class WorkoutPreview extends Vue {

  @Prop({ required: true })
  workout: WorkoutData

  @Prop({ required: true })
  workoutLiveData: WorkoutLiveData

  @Prop({ required: true })
  videoAutoplay: boolean

  @Prop({ required: true })
  currentExercise: WorkoutExercise

  @Prop({ required: true })
  svgCircleSettings: any

  @Prop({ required: true })
  exerciseStepsDescription: string[][]

  @Prop({ required: true })
  details: any[]

  @Prop({ required: true })
  timerString: string

  @Prop({ required: true })
  closePage: () => void

  @Prop({ required: true })
  updateWorkoutStateButton: () => void

  @Prop({ required: true })
  videoUrl: string

  showOverlayBackground: boolean = false

  mounted () {
    const video = this.$refs['exercise-video'] as HTMLVideoElement
    video.addEventListener('loadeddata', () => this.showOverlayBackground = true)
  }

  beforeDestroy () {
    this.showOverlayBackground = false
  }

  render (h: CreateElement) {
    const { currentExerciseIndex, isWorkoutPaused } = this.workoutLiveData
    const exerciseName = this.$te(`EXERCISE[${this.currentExercise.exercise.number}].NAME`) ?
      this.$t(`EXERCISE[${this.currentExercise.exercise.number}].NAME`) : this.currentExercise.exercise.name

    return (
      <div class='live-workout-wrapper'>
        <MobileLandscapeNotSupportedOverlay />
        <div class='video-wrapper'>
          <div class={this.showOverlayBackground ? 'preview-overlay preview-overlay-background' : 'preview-overlay'}>
            <Button class='leave-workout' type='outline' label={this.$t('LEAVE_WORKOUT')} click={
              () => this.closePage()}/>
            {this.workoutLiveData.currentExerciseIndex > 0 ? <Subtitle1>{this.$t('EXERCISE_BREAK')}</Subtitle1> : ''}
          </div>
          <video
            class={`${this.currentExercise.side !== 'right' ? '' : 'mirrored'}`}
            id='exercise-video-preview'
            ref={'exercise-video'}
            autoPlay={this.videoAutoplay}
            loop
            src={this.videoUrl}
            playsInline
          />
        </div>
        <div class='live-data-wrapper'>
          <div class='live-data'>
            <div class='exercise-name'>
              <Subtitle1>
                <span>{this.$t('UPCOMING_EXERCISE_PRE_MESSAGE')}: </span>{exerciseName}
              </Subtitle1>
            </div>
            <div class='workout-data'>
              <div class='exercise-info-wrapper'>
                <div class='exercise-flex-container'>
                  {
                    this.details.map(({ icon, label }) => (
                      <div class={`exercise-info-item ${ icon.indexOf('no-equipment') >= 0 ? 'no-equipment' : ''}`}>
                        <Icon name={icon}/>
                        <Subtitle2>{label}</Subtitle2>
                      </div>
                    ))
                  }
                </div>
                <div class='exercise-info-spacer'/>
              </div>
              <div class='initial-steps'>
                {this.exerciseStepsDescription[currentExerciseIndex].map((key, index) => {
                  const message = this.$t(`EXERCISE[${this.workout.workoutExercises[currentExerciseIndex].exercise.number}].PREPARATION_INSTRUCTIONS.${key}.DEFAULT`) as string
                  return <div>
                    <Subtitle2><span
                      class='bold'>{message.substring(0, message.indexOf(' '))}</span> {message.substring(message.indexOf(' ') + 1)}
                    </Subtitle2>
                  </div>
                })}
              </div>
              <div class='preview-wrapper'>
                <div
                  style={{
                    width: this.svgCircleSettings.outerRadius * 2 + 'px'
                  }}
                  class='preview-message'>
                  <Subtitle1>
                    {this.$t('UPCOMING_EXERCISE_INFORMING_MESSAGE')}
                  </Subtitle1>
                </div>
                <div
                  class='timer preview'>
                  {this.timerString}
                </div>
              </div>

              <div class='button-wrapper'>
                <div class='state-workout-button' onClick={this.updateWorkoutStateButton}>
                  {isWorkoutPaused ? this.$t('CONTINUE') : this.$t('PAUSE')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
